<template>
  <div class="balance-letter-loading">
    <v-progress-circular v-if="isLoading" indeterminate color="primary" />
    <template v-else-if="pdfError">
      <v-icon color="error" size="40">mdi-alert-circle-outline</v-icon>
      <div class="mt-3">The balance letter PDF could not be created.</div>
      <v-btn class="mt-4" color="primary" @click="generatePdf">Try again</v-btn>
    </template>
  </div>
</template>

<script>
import invoiceService from "@/modules/Invoice/service";
import customerService from "@/modules/Customer/service";
import studentService from "@/modules/Student/service.js";
import { createBalanceLettersPdfBlob } from "./balanceLetterPdf";
import Hashids from "hashids";
const hashids = new Hashids();
import { mapGetters, mapActions } from "vuex";

export default {
  name: "pending-invoice",
  data() {
    return {
      currentDate: new Date,
      customer: null,
      isLoading: true,
      pdfError: false,
      business: null,
      students: [],
      classes: [],
      Invoice: null,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    businessDetails() {
      return this.currentBusiness || this.business;
    },
    formattedStudentNames() {
      const names = this.students.map(student => student.fullName);
      if (names.length > 1) {
        return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
      }
      return names[0] || "No students listed";
    },
    studentProgramDetails() {
      return this.students.map(student => {
        const departments = (student.ClassStudents || [])
          .map(enrollment => enrollment.Class && enrollment.Class.name)
          .filter(Boolean);
        const classrooms = (student.ClassRoomStudents || [])
          .map(enrollment => enrollment.ClassRoom && enrollment.ClassRoom.name)
          .filter(Boolean);
        const teachers = (student.ClassRoomStudents || []).reduce((names, enrollment) => {
          const classroomTeachers = enrollment.ClassRoom && enrollment.ClassRoom.ClassRoomTeachers;
          (classroomTeachers || []).forEach(assignment => {
            if (assignment.Teacher && assignment.Teacher.name) names.push(assignment.Teacher.name);
          });
          return names;
        }, []);

        return {
          id: student.id,
          name: student.fullName || [student.firstName, student.lastName].filter(Boolean).join(" "),
          departments: this.uniqueNames(departments),
          classrooms: this.uniqueNames(classrooms),
          teachers: this.uniqueNames(teachers),
        };
      });
    },
  },
  async created() {
    await this.getCustomer();
    await this.getStudents();
    
    if (this.$route.meta.public) {
      await this.loadPublicData();
    } else {
      await this.loadData();
    }
    if (!this.currentBusiness) await this.initUser();
    document.title = "taleem | Balance Letter";
    await this.generatePdf();
  },
  methods: {
    ...mapActions("global", ["initUser"]),
    uniqueNames(names) {
      const unique = [...new Set(names)];
      return unique.length ? unique.join(", ") : "Not assigned";
    },
    getCustomer() {
      const id = hashids.decode(this.$route.params.id);
      return customerService.getById(id).then((response) => {
        this.customer = response.data;
      });
    },
    getStudents() {
      return studentService.getAll({CustomerId: this.customer.id}).then(response => {
        this.students = response.data;
        this.classes = []
        this.students.forEach(student => {
          (student.ClassStudents || []).forEach(classStudent => {
            let rowFound = this.classes.find(({ id }) => id == classStudent.ClassId);
            if(!rowFound && classStudent.Class)
              this.classes.push(classStudent.Class)
          })
        })
      });
    },
    stripHTML(html) {
      if (!html) return "";
      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      return tempElement.textContent || tempElement.innerText || '';
    },
    loadPublicData() {
      const id = hashids.decode(this.$route.params.id);
      const key = this.$route.query.key;
      const where = {
        CustomerId: id,
        due: true,
        key: key,
      };
      return invoiceService.getAll(where).then((response) => {
        // console.log("response invoice", response);
        this.$Progress.finish();
        this.Invoice = response.data;
        this.business = response.business;
      });
    },
    loadData() {
      const id = hashids.decode(this.$route.params.id);

      const where = {
        CustomerId: id,
        due: true,
      };

      return invoiceService.getAll(where).then((response) => {
        this.Invoice = response.data;
        this.count = response.count;
        this.business = response.business;
        return response;
      });

    },
    async generatePdf() {
      this.isLoading = true;
      this.pdfError = false;

      try {
        const business = this.businessDetails;
        if (!business || !this.customer) throw new Error("Balance letter data is unavailable");

        const blob = await createBalanceLettersPdfBlob({
          business,
          letters: [{ customer: this.customer, students: this.students }],
          date: this.$moment(this.currentDate).format("MMM DD YYYY"),
        });
        window.location.replace(URL.createObjectURL(blob));
      } catch (error) {
        this.isLoading = false;
        this.pdfError = true;
      }
    },
  },
};
</script>

<style scoped>
.balance-letter-loading {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
}
</style>
